import { defineComponent, toRefs } from 'vue';
import { getLicenseMemberPage } from '@/api/license/licenseMemberApi';
import { useFetchPage } from '@/composition/fetch/index';
export default defineComponent({
    name: 'LicenseMember',
    components: {
        Paging: () => import('@/components/Paging/index.vue')
    },
    props: {
        licenseSeq: {
            type: [Number, String],
            required: true
        },
        companyId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const { state, request, changePage } = useFetchPage(getLicenseMemberPage);
        request({ licenseSeq: props.licenseSeq, companyId: props.companyId });
        const { loading, data } = toRefs(state);
        const headers = [
            { text: 'Seq', value: 'lmCmSeq' },
            { text: 'User ID or Email', value: 'userId' },
            { text: 'Detail', value: 'detail', width: 200 }
        ];
        return {
            headers,
            loading,
            data,
            changePage
        };
    }
});
